import './styles.css';

export type RadioButtonProps = React.HTMLAttributes<HTMLDivElement> & {
	id: string;
	label: string;
	value: string;
	clickHandler: React.ChangeEventHandler<HTMLInputElement>;
	active: boolean;
	className?: string;
};

export const RadioButton: React.FC<RadioButtonProps> = ({
	id,
	label,
	clickHandler,
	value,
	active,
	className,
	...props
}) => {
	return (
		<div
			className={`radio-button${className ? ` ${className}` : ''}`}
			{...props}
		>
			<input
				type="radio"
				id={id}
				name={label.toLowerCase().replace(/[^a-z0-9]/g, '-')}
				onChange={clickHandler}
				value={value}
				checked={active}
			/>

			<label htmlFor={id}>{label}</label>
		</div>
	);
};
